import {
  CARDDETAIL,
  CARDHISTORY,
  CARDITEM,
  CARDSTATEMENT,
  VERIFICATION,
  RESPONSEVERITYCARD,
} from "app/shared/services/services-model.type";
import { ParamCardRequest } from "../list-card/list-card.web";
import {
  SET_CARD_STORE,
  SET_CARD_RESET,
  SET_LIMIT_4_NUMBER_DIGIT,
  FETCH_CARD_LIST_REQUEST,
  FETCH_CARD_LIST_SUCCESS,
  FETCH_CARD_LIST_FAILURE,
  FETCH_CARD_DETAIL_REQUEST,
  FETCH_CARD_DETAIL_SUCCESS,
  FETCH_CARD_DETAIL_FAILURE,
  FETCH_CARD_ACTIVATE_REQUEST,
  FETCH_CARD_ACTIVATE_SUCCESS,
  FETCH_CARD_ACTIVATE_FAILURE,
  FETCH_CARD_LOCK_UNLOCK_REQUEST,
  FETCH_CARD_LOCK_UNLOCK_SUCCESS,
  FETCH_CARD_LOCK_UNLOCK_FAILURE,
  FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_REQUEST,
  FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_SUCCESS,
  FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_FAILURE,
  FETCH_CARD_FULL_NUMBER_REQUEST,
  FETCH_CARD_FULL_NUMBER_SUCCESS,
  FETCH_CARD_FULL_NUMBER_FAILURE,
  FETCH_CARD_STATEMENT_REQUEST,
  FETCH_CARD_STATEMENT_SUCCESS,
  FETCH_CARD_STATEMENT_FAILURE,
  FETCH_CARD_PHYSICAL_REGISTER_REQUEST,
  FETCH_CARD_PHYSICAL_REGISTER_SUCCESS,
  FETCH_CARD_PHYSICAL_REGISTER_FAILURE,
  FETCH_CARD_AUTHORIZATION_KEY_REQUEST,
  FETCH_CARD_AUTHORIZATION_KEY_SUCCESS,
  FETCH_CARD_AUTHORIZATION_KEY_FAILURE,
  FETCH_CARD_HISTORY_REQUEST,
  FETCH_CARD_HISTORY_SUCCESS,
  FETCH_CARD_HISTORY_FAILURE,
} from "./actions.type";
import {
  CardState,
  SetCardStore,
  SetCardReset,
  SetLimit4NumDigit,
  FetchCardListRequest,
  FetchCardListSuccess,
  FetchCardListFailure,
  FetchCardDetailRequest,
  FetchCardDetailSuccess,
  FetchCardDetailFailure,
  FetchCardActivateRequest,
  FetchCardActivateSuccess,
  FetchCardActivateFailure,
  FetchCardUpdateStatusRequest,
  FetchCardUpdateStatusSuccess,
  FetchCardUpdateStatusFailure,
  FetchCardUpdateEComStatusRequest,
  FetchCardUpdateEComStatusSuccess,
  FetchCardUpdateEComStatusFailure,
  FetchCardFullNumRequest,
  FetchCardFullNumSuccess,
  FetchCardFullNumFailure,
  FetchCardStatementRequest,
  FetchCardStatementSuccess,
  FetchCardStatementFailure,
  FetchCardPhysicalRegisterRequest,
  FetchCardPhysicalRegisterSuccess,
  FetchCardPhysicalRegisterFailure,
  ParamCardHistory,
  ParamCardPhysicalRegister,
  FetchCardAuthorizationRequest,
  FetchCardAuthorizationSuccess,
  FetchCardAuthorizationFailure,
  FetchCardHistoryRequest,
  FetchCardHistorySuccess,
  FetchCardHistoryFailure,
  Limit4NumberDigit,
} from "./types";

export const setCardStore = (payload: CardState): SetCardStore => ({
  type: SET_CARD_STORE,
  payload,
});

export const setCardReset = (): SetCardReset => ({
  type: SET_CARD_RESET,
});

export const setLimit4NumDigit = (payload?: Limit4NumberDigit[]): SetLimit4NumDigit => ({
  type: SET_LIMIT_4_NUMBER_DIGIT,
  payload,
});

export const fetchCardListRequest = (payload?: string, showLoading?: boolean): FetchCardListRequest => ({
  type: FETCH_CARD_LIST_REQUEST,
  payload,
  showLoading,
});

export const fetchCardListSuccess = (payload?: CARDITEM[]): FetchCardListSuccess => ({
  type: FETCH_CARD_LIST_SUCCESS,
  payload,
});

export const fetchCardListFailure = (payload?: string): FetchCardListFailure => ({
  type: FETCH_CARD_LIST_FAILURE,
  payload,
});

export const fetchCardDetailRequest = (payload: string, showLoading?: boolean): FetchCardDetailRequest => ({
  type: FETCH_CARD_DETAIL_REQUEST,
  payload,
  showLoading,
});

export const fetchCardDetailSuccess = (payload?: CARDDETAIL): FetchCardDetailSuccess => ({
  type: FETCH_CARD_DETAIL_SUCCESS,
  payload,
});

export const fetchCardDetailFailure = (payload?: string): FetchCardDetailFailure => ({
  type: FETCH_CARD_DETAIL_FAILURE,
  payload,
});

export const fetchCardActivateRequest = (payload?: ParamCardRequest): FetchCardActivateRequest => ({
  type: FETCH_CARD_ACTIVATE_REQUEST,
  payload,
});

export const fetchCardActivateSuccess = (payload?: VERIFICATION): FetchCardActivateSuccess => ({
  type: FETCH_CARD_ACTIVATE_SUCCESS,
  payload,
});

export const fetchCardActivateFailure = (payload?: string): FetchCardActivateFailure => ({
  type: FETCH_CARD_ACTIVATE_FAILURE,
  payload,
});

export const fetchCardUpdateStatusRequest = (payload?: string, status?: boolean): FetchCardUpdateStatusRequest => ({
  type: FETCH_CARD_LOCK_UNLOCK_REQUEST,
  payload,
  status,
});

export const fetchCardUpdateStatusSuccess = (payload?: VERIFICATION): FetchCardUpdateStatusSuccess => ({
  type: FETCH_CARD_LOCK_UNLOCK_SUCCESS,
  payload,
});

export const fetchCardUpdateStatusFailure = (payload?: string): FetchCardUpdateStatusFailure => ({
  type: FETCH_CARD_LOCK_UNLOCK_FAILURE,
  payload,
});

export const fetchCardUpdateEComStatusRequest = (payload?: string, status?: boolean): FetchCardUpdateEComStatusRequest => ({
  type: FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_REQUEST,
  payload,
  status,
});

export const fetchCardUpdateEComStatusSuccess = (payload?: VERIFICATION): FetchCardUpdateEComStatusSuccess => ({
  type: FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_SUCCESS,
  payload,
});

export const fetchCardUpdateEComStatusFailure = (payload?: string): FetchCardUpdateEComStatusFailure => ({
  type: FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_FAILURE,
  payload,
});

export const fetchCardFullNumRequest = (payload?: string): FetchCardFullNumRequest => ({
  type: FETCH_CARD_FULL_NUMBER_REQUEST,
  payload,
});

export const fetchCardFullNumSuccess = (payload?: VERIFICATION): FetchCardFullNumSuccess => ({
  type: FETCH_CARD_FULL_NUMBER_SUCCESS,
  payload,
});

export const fetchCardFullNumFailure = (payload?: string): FetchCardFullNumFailure => ({
  type: FETCH_CARD_FULL_NUMBER_FAILURE,
  payload,
});

export const fetchCardHistoryRequest = (payload?: ParamCardHistory): FetchCardHistoryRequest => ({
  type: FETCH_CARD_HISTORY_REQUEST,
  payload,
});

export const fetchCardHistorySuccess = (payload?: CARDHISTORY[]): FetchCardHistorySuccess => ({
  type: FETCH_CARD_HISTORY_SUCCESS,
  payload,
});

export const fetchCardHistoryFailure = (payload?: string): FetchCardHistoryFailure => ({
  type: FETCH_CARD_HISTORY_FAILURE,
  payload,
});

export const fetchCardStatementRequest = (payload?: string): FetchCardStatementRequest => ({
  type: FETCH_CARD_STATEMENT_REQUEST,
  payload,
});

export const fetchCardStatementSuccess = (payload?: CARDSTATEMENT[]): FetchCardStatementSuccess => ({
  type: FETCH_CARD_STATEMENT_SUCCESS,
  payload,
});

export const fetchCardStatementFailure = (payload?: string): FetchCardStatementFailure => ({
  type: FETCH_CARD_STATEMENT_FAILURE,
  payload,
});

export const fetchCardPhysicalRegisterRequest = (payload?: ParamCardPhysicalRegister): FetchCardPhysicalRegisterRequest => ({
  type: FETCH_CARD_PHYSICAL_REGISTER_REQUEST,
  payload,
});

export const fetchCardPhysicalRegisterSuccess = (payload?: CARDITEM[]): FetchCardPhysicalRegisterSuccess => ({
  type: FETCH_CARD_PHYSICAL_REGISTER_SUCCESS,
  payload,
});

export const fetchCardPhysicalRegisterFailure = (payload?: string): FetchCardPhysicalRegisterFailure => ({
  type: FETCH_CARD_PHYSICAL_REGISTER_FAILURE,
  payload,
});

export const fetchCardAuthorizationRequest = (
  payload?: RESPONSEVERITYCARD,
  code?: string,
  showLoading?: boolean,
): FetchCardAuthorizationRequest => ({
  type: FETCH_CARD_AUTHORIZATION_KEY_REQUEST,
  payload,
  code,
  showLoading,
});

export const fetchCardAuthorizationSuccess = (payload?: any): FetchCardAuthorizationSuccess => ({
  type: FETCH_CARD_AUTHORIZATION_KEY_SUCCESS,
  payload,
});

export const fetchCardAuthorizationFailure = (errorOTP: boolean, payload?: string): FetchCardAuthorizationFailure => ({
  type: FETCH_CARD_AUTHORIZATION_KEY_FAILURE,
  errorOTP,
  payload,
});
